import MortgageLienReview from '../../components/TaskDetail/TaskSpecificContent/MortgageLienReview/MortgageLienReview';

export const TASK_SPECIFIC_MULTIPLE_FORMS_CONTENT = {
  mortgage_statement: {
    content: MortgageLienReview,
    actionDescription: 'Multiple mortgage statements were uploaded. Add additional mortgage(s)?',
    actionName: 'Add additional mortgage(s)',
  },
};
